import BangPicker from './picker.vue'

const install = function (Vue) {
    Vue.component(BangPicker.name, BangPicker);
}
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}
export default install



